import React, { useEffect, useRef } from 'react';
import {
  LatLngExpression,
  Map as LeafletMap,
} from 'leaflet';
import { GeoJsonObject } from 'geojson';
import { useFetch } from 'usehooks-ts';
import hash from 'object-hash';
import {
  MapContainer,
  TileLayer,
  GeoJSON,
} from 'react-leaflet';
import MarkerComponent from './Marker';

import './style.scss';
import 'leaflet/dist/leaflet.css';
import { API_URL, API_URL_OPTIONS, WIDGET_OPTIONS } from '../../../../shared/config/constants';

interface Props {
  marker?: LatLngExpression,
  setMap: (map: LeafletMap) => void
  movedMarker: (latlng: LatLngExpression, clickedFirstMarker: boolean) => void
  map: LeafletMap,
}

const Map: React.FC<Props> = React.memo(({
  marker,
  setMap,
  movedMarker,
  map,
}) => {
  const mapContainerRef = useRef<LeafletMap>(null);
  const defaultPosition: LatLngExpression = [52.2129919, 5.2793703];
  const { data } = useFetch<GeoJsonObject>(`${API_URL}/v1/reports/boundary`, API_URL_OPTIONS);

  useEffect(() => {
    if (mapContainerRef.current) {
      setMap(mapContainerRef.current);
      if (marker) {
        mapContainerRef.current.setZoom(12);
      }
    }
  });

  return (
    <div className="ReportsMap">
      <MapContainer
        ref={mapContainerRef}
        center={marker || defaultPosition}
        zoom={8}
        scrollWheelZoom={false}
        style={{ height: '45rem', zIndex: 0 }}
      >
        {data && (
          <GeoJSON
            key={data && hash(data)}
            data={data}
            style={{
              fillOpacity: 0.20,
              color: 'red',
              opacity: 0,
            }}
          />
        )}
        <TileLayer
          attribution='Tiles by <a href="http://mapbox.com">MapBox</a>'
          url={`https://api.mapbox.com/styles/v1/mapbox/streets-v10/tiles/256/{z}/{x}/{y}?access_token=${String(WIDGET_OPTIONS?.mapboxAccessToken)}`}
        />
        <MarkerComponent
          map={map}
          defaultPosition={marker}
          movedMarker={movedMarker}
        />
      </MapContainer>
    </div>
  );
});

export default Map;
